import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersActivityListComponent } from './users-activity-list/users-activity-list.component';

const routes: Routes = [
    {
        path: 'usersActivity',
        children: [
            { path: '', component: UsersActivityListComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UsersActivityRoutingModule { }
